@if ($configSchema() != null) {
    <div class="form-group mt-4">
        <h5>Configurações do E-Docs</h5>
        <hr class="mt-0 mb-4" />
    </div>

    <div class="form-group mt-4 mb-2">
        <h6 class="d-inline-block">Destinatário</h6>
    </div>

    <!-- Seletor de destinatário -->
    <div featureHint="flowObjectDetails|ForwardRecipientMode" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right">
        <mat-radio-group class="recipient-mode mb-2" id="recipientMode" name="recipientMode" color="primary"
                         [ngModel]="$recipientMode()"
                         [required]="true"
                         (ngModelChange)="recipientModeChange($event)"
        >
            @if ($shouldShowOwnRole()){
                <mat-radio-button [value]="RecipientMode.OwnRole">Caixa do papel do solicitante do Fluxo</mat-radio-button>
            }
            <mat-radio-button [value]="RecipientMode.ImmediateSupervisor">Gestor imediato do executor da Tarefa</mat-radio-button>
            @if ($shouldShowOwnerImmediateSupervisor()){
                <mat-radio-button [value]="RecipientMode.OwnerImmediateSupervisor">Gestor imediato do solicitante do Fluxo</mat-radio-button>
            }
            @if ($shouldShowOwnerHeadOfOrganization()){
                <mat-radio-button [value]="RecipientMode.OwnerHeadOfOrganization">Gestor do máximo órgão do solicitante do Fluxo</mat-radio-button>
            }
            <mat-radio-button [value]="RecipientMode.Fixed">Local do E-Docs fixo</mat-radio-button>
            <mat-radio-button [value]="RecipientMode.Conditional">Local do E-Docs condicional</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- Local do E-Docs fixo -->
    @if ($recipientMode() == RecipientMode.Fixed) {
        <!-- Local do E-Docs -->
        <edocs-location #edocsLocationRef
                        [_model]="$configSchemaSectionEDocsLocation()"
                        [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                        [_isReadOnlyMode]="$isReadOnlyMode()"
                        (_modelChange)="onUpdateEDocsLocation($event)"
        ></edocs-location>

        <!-- Destinatário selecionado -->
        <div class="form-group forwarding-recipient ml-6" featureHint="flowObjectDetails|ForwardSelected" featureHintHAlign="right">
            <label for="recipientName">Destinatário selecionado</label>
            <input type="text" class="form-control info-font one-button" id="recipientName" name="recipientName" readonly disabled
                   placeholder="(nenhum)"
                   [ngModel]="$configSchemaSectionEDocsLocation().name"
                   [matTooltip]="$configSchemaSectionEDocsLocation().name"
                   (change)="recipientNameChange($event.target.value)"
            >
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearDestinatario()" (keyDown)="clearDestinatario()"></i>
        </div>
    }

    <!-- Local do E-Docs condicional -->
    @if ($recipientMode() == RecipientMode.Conditional) {
        <!-- Condição -->
        <div class="condition-row ml-3px">
            <!-- Campo do Formulário -->
            <div class="form-group col-5 px-0" featureHint="flowObjectDetails|ForwardConditionalField">
                <label for="formFieldConditional">Campo do Formulário</label>

                <select class="form-control" id="formFieldConditional" name="formFieldConditional"
                        [ngModel]="$formFieldConditional()"
                        (change)="$formFieldConditional.set($event.target.value)"
                >
                    @for (option of $formFieldConditionalOptions(); track option) {
                        <option [value]="option.value">{{option.description}}</option>
                    }
                </select>
            </div>

            <!-- Operação -->
            <div class="form-group col-3 px-2" featureHint="flowObjectDetails|ForwardConditionalOperation">
                <label for="operationConditional">Operação</label>

                <select class="form-control" id="operationConditional" name="operationConditional"
                        [ngModel]="$isOperationEqualConditional()"
                        (change)="$isOperationEqualConditional.set($event.target.value)"
                >
                    <option [value]="true">IGUAL</option>
                    <option [value]="false">DIFERENTE</option>
                </select>
            </div>

            <!-- Valor do Campo -->
            <div class="form-group col-4 px-0" featureHint="flowObjectDetails|ForwardConditionalValue">
                <label for="valueConditional">Valor do Campo</label>

                <input type="text" class="form-control" id="valueConditional" name="valueConditional"
                       [ngModel]="$valueConditional()"
                       (change)="$valueConditional.set($event.target.value)"
                />
            </div>
        </div>

        <!-- Local do E-Docs -->
        <edocs-location #edocsLocationConditionalRef
                        [_model]="$configSchemaSectionEDocsLocationConditional()"
                        [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                        [_isReadOnlyMode]="$isReadOnlyMode()"
                        [_isConditionalForwarding]="true"
                        (_modelChange)="onUpdateEDocsLocationConditional($event)"
        ></edocs-location>

        <!-- Painel de condições -->
        <ng-container>
            @if ($configSchema().taskForward.conditionalRecipients.length == 0) {
                <div class="conditions-container empty mt-4 mb-3 p-2"
                     featureHint="flowObjectDetails|ForwardConditionalPanel" featureHintHAlign="right" featureHintShowOn="right"
                >
                    <span class="info-font">Nenhuma condição adicionada</span>
                </div>
            } @else {
                <div class="conditions-container mt-4 mb-3 p-2"
                     featureHint="flowObjectDetails|ForwardConditionalPanel" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
                >
                    @for (condition of $configSchema().taskForward.conditionalRecipients; track condition; let i = $index) {
                        <div class="condition p-2">
                            <pre class="m-0" [safeHtmlContent]="prettyPrint(condition)"></pre>

                            @if (i > 0) {
                                <i class="fas fa-arrow-up ml-2" matTooltip="Mover condição para cima"
                                   (click)="moveCondition(condition, true)"
                                   (keyDown)="moveCondition(condition, true)"
                                ></i>
                            }

                            @if (i < $configSchema().taskForward.conditionalRecipients.length - 1) {
                                <i class="fas fa-arrow-down ml-2" matTooltip="Mover condição para baixo"
                                   (click)="moveCondition(condition)"
                                   (keyDown)="moveCondition(condition)"
                                ></i>
                            }

                            <i class="fas fa-trash-alt ml-2" matTooltip="Remover condição"
                               (click)="removeCondition(condition)"
                               (keyDown)="removeCondition(condition)"
                            ></i>
                        </div>
                    }

                    <button type="button" class="btn btn-outline-danger"
                            [disabled]="$isReadOnlyMode()"
                            (click)="removeAllConditions()"
                            (keyDown)="removeAllConditions()"
                    >
                        <i class="fas fa-times-circle mr-1"></i>
                        <span>Remover todas as condições</span>
                    </button>
                </div>
            }
        </ng-container>
    }

    <div class="form-group mt-4 mb-2">
        <h6 class="d-inline-block">Nível de Acesso do Registro de Encaminhamento</h6>
    </div>

    <!-- Nível de Acesso -->
    <access-level #accessLevelRef
                  [_model]="$configSchemaSectionAccessLevel()"
                  [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                  [_isReadOnlyMode]="$isReadOnlyMode()"
                  (_modelChange)="onUpdateAccessLevel($event)"
    ></access-level>
}
